export default __webpack_public_path__ + "static/media/card1@3x.8e7d30dc.png";